import type { Locale, MessageKey } from "./locale-catalog";
import { messages } from "./locale-catalog";

export type Translate = (
  key: MessageKey,
  values?: Record<string, string | number>,
) => string;

export function translate(
  locale: Locale,
  key: MessageKey,
  values: Record<string, string | number> = {},
): string {
  return messages[locale][key].replace(/\{(\w+)\}/g, (_, name: string) =>
    String(values[name] ?? `{${name}}`),
  );
}
